<template>
  <div class="up-pwd" v-if="ifshow">
    <div class="bg"></div>
    <div class="upBox">
      <div class="title">
        <strong>{{ $t("upPwd.changePassword") }}</strong>
        <div class="fr" @click="down()">X</div>
      </div>
      <div class="inputBox">
        <span class="inpName">{{ $t('upPwd.originalPassword') }}：</span>
        <input type="text" v-model="oldPwd" :placeholder="$t('upPwd.pleaseEnterYourOldPassword')" />
      </div>
      <div class="inputBox">
        <span class="inpName">{{ $t('upPwd.newPassword') }}：</span>
        <input type="password" v-model="userPwd" :placeholder="$t('upPwd.pleaseEnterNewPassword')" />
      </div>
      <div class="inputBox">
        <span class="inpName">{{ $t('upPwd.confirmPassword') }}：</span>
        <input type="password" v-model="twoPwd" :placeholder="$t('upPwd.pleaseConfirmYourPassword')" />
      </div>
      <div class="inputBox">
        <span class="inpName"></span>
        <div class="but" @click="updatePwd()">{{ $t('upPwd.confirmToSubmit') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ifshow: "",
      oldPwd: "",
      userPwd: "",
      twoPwd: "",
    };
  },
  methods: {
    async updatePwd() {
      if(this.userPwd!=this.twoPwd){
        return this.$message.error('两次输入密码不一致')
      }
      let { data: res } = await this.$http.post("/c/user/updatePwd",{
        oldPwd:this.oldPwd,
        userPwd:this.userPwd
      });
      if (res.code != 200) {
        return this.$message.error(res.message);
      }
      this.$message.success("修改成功");
    },
    up() {
      this.ifshow = true;
    },
    down() {
      this.ifshow = false;
    },
  },
};
</script>
<style lang="less" scoped>
.up-pwd {
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
}
.bg {
  position: fixed;
  top: 0;
  left: 0;
  background-color: #0008;
  height: 100vh;
  width: 100vw;
}
.upBox {
  width: 31.25rem;
  height: 24.375rem;
  background-color: #fff;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: .9375rem;
  padding: 1.875rem;
  box-sizing: border-box;
  .title {
    text-align: center;
    font-size: 1.375rem;
    margin-bottom: 1.875rem;
  }
  .inputBox {
    // border-bottom: .0313rem solid #ccc;
    height: 4.0625rem;
    .limg {
      width: 1.25rem;
      height: 1.25rem;
      margin-right: .625rem;
    }
    .inpName {
      width: 5.625rem;
      display: inline-block;
    }
    input {
      width: 18.75rem;
      line-height: 2.8125rem;
      outline: none;
      background-color: #f1f1f1;
      border: .0313rem solid #ccc;
      padding: 0 1.25rem;
      box-sizing: border-box;
    }
    .imgCode {
      display: inline-block;
      float: right;
      margin-top: .625rem;
      width: 6.25rem;
      height: 2.5rem;
      // padding: .625rem;
      text-align: center;
      background-color: #f1f1f1;
    }
  }
  .but {
    height: 3.125rem;
    background-color: rgb(67, 188, 183);
    text-align: center;
    width: 18.75rem;
    line-height: 3.125rem;
    color: #fff;
    margin-top: 0rem;
    border-radius: .3125rem;
    display: inline-block;
  }
}
</style>